/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactAlert = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 14c3 0 5.261.703 6.788 1.992C20.336 17.3 21 19.1 21 21v1h-2v-1c0-1.416-.479-2.616-1.502-3.48C16.453 16.638 14.714 16 12 16c-2.715 0-4.453.638-5.498 1.52C5.479 18.384 5 19.584 5 21v1H3v-1c0-1.9.664-3.7 2.212-5.008C6.739 14.703 9 14 12 14zm10-1h-2v-2h2zM12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm10 5h-2V3h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgContactAlert as ContactAlert };
